import type { Article } from '@wix/answers-api';

import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { HttpClientFactory } from '../httpClient';

const { clientTopology, locale } = renderModel.get();

export const getArticlesByCategoryId = async (
  id: string,
  pageSize: number,
  page: number,
  httpClient: HttpClientFactory,
): Promise<Article[]> => {
  try {
    const response = await httpClient
      .getInstance()
      .get<{ articles: Article[] }>(`${clientTopology.categoriesUrl}/${id}/articles`, {
        params: {
          pageSize,
          page,
          locale,
        },
      });
    return response.data.articles;
  } catch (error) {
    logger.log({
      message: `fail to fetch Article by category Id: ${id}`,
      error,
    });
    console.error(error);
    throw error;
  }
};
